import React, { createContext, useContext, useState } from "react";

const CanvasContext = createContext();

export const CanvasProvider = ({ children }) => {
  const [widthLienzo, setWidthLienzo] = useState(1100);
  const [heightLienzo, setHeightLienzo] = useState(800);
  const [nameLienzo, setNameLienzo] = useState("dibujo");

  return (
    <CanvasContext.Provider
      value={{
        widthLienzo,
        setWidthLienzo,
        heightLienzo,
        setHeightLienzo,
        nameLienzo,
        setNameLienzo,
      }}
    >
      {children}
    </CanvasContext.Provider>
  );
};

export const useCanvasConfig = () => useContext(CanvasContext);